import { Component, Input, OnInit } from '@angular/core';

import { Party } from '@shared/party/models';
import { Subscription } from 'rxjs';
import { ClockService } from '@tablesready/frontend-alerts-bar';

@Component({
  selector: 'tablesready-waitlist-quoted-time',
  templateUrl: './waitlist-quoted-time.component.html',
  styleUrls: ['./waitlist-quoted-time.component.scss'],
})
export class WaitlistQuotedTimeComponent<T extends Party> implements OnInit {
  @Input() party?: T;
  @Input() label = 'quoted time';
  @Input() timezone = '';

  now?: number;

  private readonly subscription = new Subscription();

  constructor(private readonly clockService: ClockService) {}

  timeDeltaNgClass(partyTime: number): string {
    return partyTime >= this.now ? 'lead on-time' : 'lead late';
  }

  ngOnInit(): void {
    const timeSub = this.clockService.clock$
      .subscribe((now) => {
        this.now = now;
      });

    this.subscription.add(timeSub);
  }
}
